import { all } from 'redux-saga/effects';

import { env } from '@/env';

import { requestInterceptor } from './requestInterceptor';
import { wakeup } from './wakeup';

export function* saga() {
    if (!env.VITE_DEMO && !env.VITE_SAAS) {
        yield all([wakeup(), requestInterceptor()]);
    }
}
